import React from 'react';
import classes from './styles/index.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const AuthenticationActionButton = ({ children, styleType, className, onClick }) => {
	const buttonClassNames = classNames(className, classes.authenticationActionButton, {
		[classes.authenticationActionButton_default]: styleType === 'default',
		[classes.authenticationActionButton_primary]: styleType === 'primary',
	});

	return (
		<button
			className={buttonClassNames}
			type='button'
			onClick={onClick}
		>
			{children}
		</button>
	);
};

AuthenticationActionButton.propTypes = {
	children: PropTypes.node,
	styleType: PropTypes.string,
	className: PropTypes.string,
	onClick: PropTypes.func,
};

AuthenticationActionButton.defaultProps = {
	styleType: 'default',
};

export { AuthenticationActionButton };
